import { KeyboardReturn, SvgIconComponent } from '@mui/icons-material';
import { FormControl, IconButton, Input, InputAdornment, InputLabel } from '@mui/material';
import { FC } from 'react';
import { v4 } from 'uuid';
import { AppIcons } from '../../settings/icons';

interface IProps 
{
  title: string;
  value: string;
  type: string;
  icon?: SvgIconComponent;
  onChange: (value: string)=>void;
  onAdd?: (value: string)=>void;
}

const TextInputField: FC<IProps> = ({ title, value, type, icon, onChange, onAdd }) => 
{
    const Icon = icon ?? AppIcons.DefaultTextInput;
    const inputId = `text-input-${v4()}`;
    return (<FormControl sx={{ m: 1, width: '335px' }} variant="standard">
        <InputLabel htmlFor={inputId}>
            {title}
        </InputLabel>
        <Input
            id={inputId}
            type={type}
            value={value}
            onChange={(evt)=>{
                onChange(evt.currentTarget.value);
            }}
            startAdornment={
                <Icon sx={{verticalAlign: "bottom", mr: "5px"}} />
            }
            endAdornment={
                onAdd ?
                    <InputAdornment position="end">
                        <IconButton
                            aria-label=""
                            onClick={(evt)=>{
                                onAdd(value);
                            }}
                        >
                            <KeyboardReturn />
                        </IconButton>
                    </InputAdornment> : <></>
            }
        />
    </FormControl>);
};

export default TextInputField;